import { CSSProperties } from "react"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import { HTML as _HTML } from "../../contentType"
import DataDummy from "../../landing-edit/DataDummy"
import { IDataComponentsProps } from "../DataComponents"
import { DataContentAnimateContainer } from "./DataContentAnimateContainer"
import { DataContentPositionContainer } from "./DataContentPositionContainer"
import Background from "../Background"

/* Protopia Ecosystem component */
export interface ISectionDataSectionDataFeedProps extends IDataComponentsProps {
   
}
const SectionDataFeed = (props: ISectionDataSectionDataFeedProps): JSX.Element => {
    const section = props.section  || {}
    // 
    if(!section) return <></>

    return <div className={`landing-data-components-container ${section.className || ""}`} style={{ gap: section.gap }}>
        {
            props.data.map((data, i) => {
                if(data.isHidden) {
                    return <DataDummy key={ data.id } data={data} section={props.section} /> 
                }
                const type = data.type
                const DataComponent = type && components()[ type ]
                    ?
                    components()[ type ].c
                    :
                    _HTML
                
                return <DataContentAnimateContainer {...props}  section={ section }  i={i} style={{ ...data.containerStyle, }} key={data.id}>
                    <DataContentPositionContainer {...props}  section={ section }  i={i} >
                        <>
                        <DataComponent  
                            section={ section } 
                            data={ { ...data, type } } 
                            i={ i }
                        />
                        <div
                            style={{
                                position: 'absolute',
                                width: '100%',
                                height: '100%',
                                top: 0,
                                left: 0,
                                opacity: 1,
                                zIndex: -1
                            }}
                        >
                            <Background section={ data } />
                        </div> 
                    </>
                    </DataContentPositionContainer>
                </DataContentAnimateContainer>
            })
        }
    </div>
}
export default SectionDataFeed

export interface IDataContentContainer extends ISectionDataSectionDataFeedProps{
    children: JSX.Element
    i: number
    proportia?: number
    style?: CSSProperties
    className?: string
}
